module.exports = __webpack_public_path__ + "img/grade control.e132fbf2.svg";